import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { SidebarWorkspace } from '../../../user/types';
import { SidebarMainMenu } from './SidebarMainMenu';
import { MetrikaSideNav, SidebarMenuContainer } from './styles';

export const SidebarMain_: React.FC<{
   expanded: boolean;
   onToggle: () => void;
   workspaces: SidebarWorkspace[];
}> = ({ expanded, workspaces, onToggle }) => {
   return (
      <MetrikaSideNav
         expanded={expanded}
         isChildOfHeader={true}
         isFixedNav={false}
         isPersistent={true}
         onOverlayClick={onToggle}
         addFocusListeners={false}
         addMouseListeners={false}
         aria-label="Side navigation"
      >
         <Switch>
            {workspaces
               .filter((w) => w.enabled)
               .map((w) => (
                  <Route key={w.id} path={'/' + w.id}>
                     <SidebarMenuContainer>
                        <SidebarMainMenu onToggle={onToggle} workspace={w} />
                     </SidebarMenuContainer>
                  </Route>
               ))}
         </Switch>
      </MetrikaSideNav>
   );
};

export const SidebarMain = React.memo(SidebarMain_);
